var exports = {
  "i": "xcc377c0b--f42f85--main",
};

module.exports = exports;
